import { parseOrderForAnalytics } from '@waybetter/wb-analytics';

import { events, trackEvent } from '../analytics';

import { appendGameUrl } from './append-game-url';

export const trackStartMembershipOrder = ({ gameId, order, userId }) => {
  order.orderItems = appendGameUrl(order.orderItems);

  const analyticsOrder = parseOrderForAnalytics({
    user: { id: userId },
    game: { id: gameId },
    order,
    appName: 'hub',
    referringGameId: gameId,
    decamelize: true,
  });

  trackEvent(events.CHECKOUT_STARTED, analyticsOrder);
};
